import { render, staticRenderFns } from "./VaimoSubscriptionModal.vue?vue&type=template&id=31fe8b52&scoped=true&"
import script from "./VaimoSubscriptionModal.vue?vue&type=script&lang=ts&"
export * from "./VaimoSubscriptionModal.vue?vue&type=script&lang=ts&"
import style0 from "./VaimoSubscriptionModal.vue?vue&type=style&index=0&id=31fe8b52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fe8b52",
  null
  
)

export default component.exports